module.exports = __webpack_public_path__ + "img/thumb_15.204296c4.jpg";